import { SquirrelSearchByCodeStatuses } from '../constants.js';
import { isCommerceOffer } from './commerceDataTypes.js';
export function isSquirrelSearchByCodeStatus(subject) {
    return SquirrelSearchByCodeStatuses.includes(subject);
}
export function isCommerceSquirrelOffer(subject) {
    if (!isCommerceOffer(subject)) {
        return false;
    }
    const offer = subject;
    if (offer.metaData === undefined || offer.metaData === null) {
        return false;
    }
    return ('affiliateNetwork' in offer.metaData &&
        typeof offer.metaData.affiliateNetwork === 'number' &&
        (offer.metaData.squirrelOfferStatus === undefined ||
            isSquirrelSearchByCodeStatus(offer.metaData.squirrelOfferStatus)));
}
//# sourceMappingURL=squirrel.js.map